import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { Sidebar } from '@futrli/ui-components';

import { useSidebarResetCounter } from '../../../hooks/useSidebarResetCounter/useSidebarResetCounter';
import { SharingEntityType } from '../../../core/api/sharing';
import { ShareResourceContainer } from './containers/share-resource-container/share-resource-container';
import { ShareResourceContextProvider } from './context/share-resource-context';

export interface ShareResourceSidebarProps {
  entityId?: string;
  entityType?: SharingEntityType;
  isOpen: boolean;
  onClose: () => void;
  resourceName: string;
}

export const ShareResourceSidebar = ({
  entityId,
  entityType,
  isOpen,
  onClose,
  resourceName
}: ShareResourceSidebarProps) => {
  const intl = useIntl();
  const { resetKey } = useSidebarResetCounter(isOpen);

  return (
    <Sidebar
      aria-label={intl.formatMessage({
        id: 'sharing.sidebar_aria_label',
        defaultMessage: 'Share resource sidebar'
      })}
      header={
        <Typography fontWeight="700" variant="h2">
          <FormattedMessage id="sharing.share_resource" defaultMessage="Share {resourceName}" values={{ resourceName }} />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
      size="medium"
    >
      {entityId && entityType && (
        <ShareResourceContextProvider key={resetKey} entityId={entityId} entityType={entityType}>
          <ShareResourceContainer onClose={onClose} />
        </ShareResourceContextProvider>
      )}
    </Sidebar>
  );
};
